"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultBTCRelayAPI = exports.DEFAULT_STABLE_CONFIRMATIONS = void 0;
const utils_1 = require("../utils");
exports.DEFAULT_STABLE_CONFIRMATIONS = 6;
class DefaultBTCRelayAPI {
    constructor(api, electrsAPI) {
        this.api = api;
        this.electrsAPI = electrsAPI;
    }
    getStableBitcoinConfirmations() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.query.btcRelay.stableBitcoinConfirmations().then((param) => param.toNumber());
        });
    }
    getStableParachainConfirmations() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.query.btcRelay.stableParachainConfirmations().then((param) => param.toNumber());
        });
    }
    getLatestBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.query.btcRelay.bestBlock();
        });
    }
    getLatestBlockHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.api.query.btcRelay.bestBlockHeight()).toNumber();
        });
    }
    verifyTransactionInclusion(txid, confirmations = exports.DEFAULT_STABLE_CONFIRMATIONS) {
        return __awaiter(this, void 0, void 0, function* () {
            const merkleProof = yield this.electrsAPI.getMerkleProof(txid);
            const confirmationsU32 = this.api.createType("u32", confirmations);
            // TODO: change this to RPC call
            this.api.tx.btcRelay.verifyTransactionInclusion(txid, merkleProof, confirmationsU32);
        });
    }
    isBlockInRelay(blockHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = yield this.api.query.btcRelay.blockHeaders((0, utils_1.addHexPrefix)(blockHash));
            return !value.isEmpty;
        });
    }
}
exports.DefaultBTCRelayAPI = DefaultBTCRelayAPI;
//# sourceMappingURL=btc-relay.js.map